import Vue from 'vue';

export default Vue.extend({
  name: 'Inputable',
  props: {
    value: { default: undefined, type: [String, Number, Array, Object, Boolean, Date] },
  },
  methods: {
    onInput(value: any) {
      this.$emit('input', value);
    },
  },
});
